























































import { Component, Prop, Vue } from "vue-property-decorator";
import { GameConfigType, GameType, PlayerType, PlayersType } from "@/types";
import { shuffle, capitalize } from "@/app/helpers";
import Constraints from "@/app/engine/constraints/Constraints";
import EmojiPicker from "@/components/EmojiPicker.vue";
import PlayerList from "@/components/game/PlayerList.vue";
import PlayerTag from "@/components/game/PlayerTag.vue";
import GalleryList from "@/components/game/GalleryList.vue";
import TopicsList from "@/components/game/TopicsList.vue";

@Component({ components: { EmojiPicker, PlayerList, PlayerTag, GalleryList, TopicsList } })
export default class Responses extends Vue {
  @Prop({ required: true }) config!: GameConfigType;
  @Prop({ required: true }) game!: GameType;
  @Prop({ required: true }) isOwner!: boolean;
  @Prop({ required: true }) player!: PlayerType;
  @Prop({ required: true }) players!: PlayersType;

  orderImages: number[] = [];
  orderTopics: number[] = [];
  response = "";
  maxLength = 50;
  minLength = 2;

  get constraint() {
    return Constraints.from(this.game.constraint);
  }

  get images() {
    return this.orderImages.map((i: number) => this.game.gallery[i]);
  }

  get role() {
    return this.game.roles[this.player.id] || "observer";
  }
  get roleText() {
    return capitalize(this.role);
  }

  get topics() {
    return this.orderTopics.map((i: number) => this.game.topics[i]);
  }

  get valid() {
    return this.response && this.response.length >= 2 && this.response.length <= this.maxLength;
  }

  submitResponse(e: Event) {
    e.preventDefault();
    if (this.valid)
      this.$root.$data.store.gameUpdate({
        responses: { [this.player.id]: { time: Date.now(), value: this.response } },
      });
  }

  mounted() {
    this.orderImages = this.role === "agent" ? [0] : shuffle([0, 1]);
    this.orderTopics = this.role === "agent" ? shuffle([0, 1]) : shuffle([0, 1, 2]);
  }
}
